export default "__VITE_ASSET__BpYunylO__"